













import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import AMSDialog from '@/components/AMSDialog.vue';
@Component({
  components: { 'ams-dialog': AMSDialog }
})
export default class AMSImg extends Vue {
  @Prop({ default: '' }) pictureKey!: string;
  @Prop({ default: 200 }) pictureWidth!: number;
  @Prop({ default: 200 }) pictureHeight!: number;
  @Prop({ default: true }) isShowImage!: boolean;
  showImage: Boolean = false;
  modalTitle: string = '查看图片';
  get imgSrc(): string {
    return `${process.env.VUE_APP_FILE_URL}/${this.pictureKey }` + `?x-oss-process=image/resize,w_${this.pictureWidth},limit_0,m_lfit`
  }
  profileUrl(url: any) {
    if (url) {
      return `${process.env.VUE_APP_FILE_URL}/${url}`;
    }
  }
  showBigImage(pic: string) {
    this.showImage = true;
  }
  confirmClose() {
    this.showImage = false;
  }
}
